import './app.css';
import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SecureRoute from '../secureRoute/index.jsx';
import {
  Layouts,
  Authentication,
  Components,
  FormBuilder
} from '../../components';
import * as sessionActionCreators from '../../modules/session';
import { AdminRoleLevel } from '../../modules/session';
import { fetchFeatureFlags } from '../../modules/featureFlags/featureFlagActions';
import AdminsListContainer from '../../pages/accounts';
import AccountDetailPageContainer from '../../pages/accounts/detail';
import AccountSettingsPageContainer from '../../pages/accounts/settings';
import TapNdonateContainer from '../../pages/tapNdonate/TapNdonate';
import CampaignPageContainer from '../../pages/campaign';
import CreateCampaignContainer from '../../pages/campaign/create';
import EditCampaignContainer from '../../pages/campaign/edit';
import ViewCampaignContainer from '../../pages/campaign/view';
import EditTeamPageContainer from '../../pages/campaign/page/edit/edit-team';
import EditFundraiserPageContainer from '../../pages/campaign/page/edit/edit-fundraiser';
import CreatePageContainer from '../../pages/campaign/page/create';
import OrganizationPageContainer from '../../pages/organization';
import CreateOrganizationContainer from '../../pages/organization/create';
import EditOrganizationContainer from '../../pages/organization/edit';
import CreateOfflineDonationContainer from '../../pages/donation/create';
import StripeConnector from '../../pages/stripe';
import SalesforceConnection from '../../pages/salesforce/salesforce-connection';
import Invite from '../../components/authentication/invite';
import DonationsListContainer from '../../pages/donation';
import DonationViewPage from '../../pages/donation/view';
import FundraiserViewPage from '../../pages/fundraiser/view';
import FundraiserViewContainer from '../../pages/campaign/view/fundraiser-view';
import TeamViewContainer from '../../pages/campaign/view/team-view';
import EditDonationContainer from '../../pages/donation/edit';
import EventPageContainer from '../../pages/event';
import ViewEventContainer from '../../pages/event/view';
import CreateEventContainer from '../../pages/event/create';
import EditEventContainer from '../../pages/event/edit';
import CloneEventContainer from '../../pages/event/clone';
import EditTicketingContainer from '../../pages/ticketing/edit';
import ViewTicketingContainer from '../../pages/ticketing/view';
import CreateTicketingContainer from '../../pages/ticketing/create';
import MerchandisePageContainer from '../../pages/merchandise';
import CreateMerchandiseContainer from '../../pages/merchandise/create';
import EditMerchandiseContainer from '../../pages/merchandise/edit';
import EditCollectionPageContainer from '../../pages/campaign/page/edit/edit-collection';
import CollectionViewContainer from '../../pages/campaign/view/collection-view';
import RecurringPageContainer from '../../pages/recurring';
import CreateRecurringDonationContainer from '../../pages/recurring/create';
import EditRecurringDonationContainer from '../../pages/recurring/edit';
import RecurringDonationViewPageContainer from '../../pages/recurring/view';
import CloneCampaignContainer from '../../pages/campaign/clone';
import CampaignPerformanceContainer from '../../pages/campaign/performance';
import EventPerformanceContainer from '../../pages/event/performance/EventPerformance';
import SalesListContainer from '../../pages/ticketing';
import FundraiserPageContainer from '../../pages/fundraisers';
import DashboardContainer from '../../pages/dashboard/index';
import DashboardCompareContainer from '../../pages/dashboard/compare/index';
import RegisterContainer from '../../pages/register';
import config from '../../constants/index';
import ping from '../../components/ping';
import InjectReCaptcha from '../../components/common/injectReCaptcha';
import PrivateRoute from './privateRoute/privateRoute';
import { userRolesStrings } from '../../constants/roles';
import EventAmbassadorViewPageContainer from '../../pages/vipProgram/view/event-view';
import CampaignAmbassadorViewPageContainer from '../../pages/vipProgram/view/campaign-view';
import ProgramViewPageContainer from '../../pages/vipProgram/view';
import CreateVipProgramContainer from '../../pages/vipProgram/create';
import EditVipProgramContainer from '../../pages/vipProgram/edit';
import CreateProgramContainer from '../../pages/vipProgram/program/create';
import EditProgramContainer from '../../pages/vipProgram/program/edit';
import EditApplicationContainer from '../../pages/vipProgram/application/edit';
import TransferDonationContainer from '../../pages/donation/transferDonation';
import Webhooks from '../../pages/webhooks';
import CreateWebhook from '../../pages/webhooks/create';
import EditWebhook from '../../pages/webhooks/edit';
import { ActiveIntegrationContainer } from '../../pages/event/activeIntegration';
import { grecaptcha } from '../../helpers/grecaptcha';
import { ExportHistoryDashboard } from '../../pages/export-history';
import TransferDonationSubscriptionContainer from '../../pages/recurring/transferDonationSubscription';
import HomePage from '../../pages/home/HomePage';
import FormBuilderPage from '../../components/formbuilder';
import { CheckInPage } from '../../pages/checkin/CheckInPage';
import FranchiseHub from '../../pages/franchise/hub/FranchiseHub';
import ContentModerationQueueScreen from '../../pages/contentModeration/screens/queue/QueueScreen';
import ContentModerationReviewEventScreen from '../../pages/contentModeration/screens/review/ReviewEventScreen';
import MfaVerification from '../../components/authentication/mfaVerification';

// System Settings
import SystemSettings from '../../pages/systemSettings';
import SystemHealth from '../../pages/systemSettings/systemHealth';
import AuditTrail from '../../pages/systemSettings/auditTrail';
import FranchisesContent from '../../pages/systemSettings/franchises/FranchisesContent';
import CreateFranchiseContent from '../../pages/systemSettings/franchises/CreateFranchiseContent';
import EditFranchiseContent from '../../pages/systemSettings/franchises/EditFranchiseContent';
import CampaignOrganizersContent from '../../pages/systemSettings/campaignOrganizers/CampaignOrganizersContent';
import CreateCampaignOrganizerContent from '../../pages/systemSettings/campaignOrganizers/CreateCampaignOrganizerContent';
import EditCampaignOrganizerContent from '../../pages/systemSettings/campaignOrganizers/EditCampaignOrganizerContent';
import EventOrganizersContent from '../../pages/systemSettings/eventOrganizers/EventOrganizersContent';
import CreateEventOrganizerContent from '../../pages/systemSettings/eventOrganizers/CreateEventOrganizerContent';
import EditEventOrganizerContent from '../../pages/systemSettings/eventOrganizers/EditEventOrganizerContent';
import AccessKeysContent from '../../pages/systemSettings/accessKeys/AccessKeysContent';
import CreateAccessKeyContent from '../../pages/systemSettings/accessKeys/CreateAccessKeyContent';
import UrlUnlocking from '../../pages/systemSettings/urlUnlocking';
import DisableOrganization from '../../pages/systemSettings/disableOrganization';
import BulkChargeGuarantee from '../../pages/systemSettings/bulkChargeGuarantee';
import AddOrganizationToEvents from '../../pages/systemSettings/addOrganizationToEvents';
import ConsentDocumentVersions from '../../pages/systemSettings/consentDocumentVersions';
import GiftMatchingPools from '../../pages/systemSettings/giftMatchingPools';
import GiftMatchingPoolCreate from '../../pages/systemSettings/giftMatchingPools/GiftMatchingPoolCreate';
import GiftMatchingPoolEdit from '../../pages/systemSettings/giftMatchingPools/GiftMatchingPoolEdit';

interface AppProps {
  isSystemAdmin: boolean;
  isOrganizationAdmin: boolean;
  isEventAdmin: boolean;
  isCampaignAdmin: boolean;
  isEventOrganizerAdmin: boolean;
  isCampaignOrganizerAdmin: boolean;
  adminRole: string | null;
  sessionKey: any;
  resumeSession: (token?: any) => void;
  fetchFeatureFlags: () => void;
}

const App = ({
  isSystemAdmin,
  isOrganizationAdmin,
  isEventAdmin,
  isCampaignAdmin,
  isEventOrganizerAdmin,
  isCampaignOrganizerAdmin,
  adminRole,
  sessionKey,
  resumeSession,
  fetchFeatureFlags
}: AppProps) => {
  useEffect(() => {
    grecaptcha(resumeSession, 'login');
    // Load application feature flags on startup, before any authentication.
    // The flags endpoint works unauthenticated, so this makes flags available
    // on the login screen and any other pre-session state.
    fetchFeatureFlags();
    // eslint-disable-next-line
  }, []);

  const userRoles: string[] = [];
  if (isSystemAdmin) userRoles.push('systemAdmin');
  if (isOrganizationAdmin) userRoles.push('organizationAdmin');
  if (isEventAdmin) userRoles.push('eventAdmin');
  if (isCampaignAdmin) userRoles.push('campaignAdmin');
  if (isEventOrganizerAdmin) userRoles.push('eventOrganizerAdmin');
  if (isCampaignOrganizerAdmin) userRoles.push('campaignOrganizerAdmin');

  // Compound role strings: context + level (for fine-grained route gating)
  if (
    isSystemAdmin &&
    (adminRole === AdminRoleLevel.Owner || adminRole === AdminRoleLevel.Admin)
  ) {
    userRoles.push(userRolesStrings.systemReadWrite);
  }
  if (isSystemAdmin && adminRole === AdminRoleLevel.Owner) {
    userRoles.push(userRolesStrings.systemOwner);
  }

  // Helper for PrivateRoute element
  const privateRoute = (allowedRoles: string[], element: React.ReactNode) => (
    <PrivateRoute userRoles={userRoles} allowedRoles={allowedRoles}>
      {element}
    </PrivateRoute>
  );

  // Fallback logger for unmatched routes
  const UnmatchedRouteLogger = () => {
    return <Navigate to="/home" replace />;
  };

  return (
    <div>
      <Routes>
        {/* Public routes */}
        <Route path="/components" element={<Components />} />
        <Route
          path="/formbuilder"
          element={
            <FormBuilderPage
              formBuilderKey="default"
              dataCallback={() => {}}
              form={{ children: [] }}
              subtext=""
              isAddressHidden={false}
              isPhoneHidden={false}
              isCountryAllowed={false}
              formQuestionsMaxLength={10}
              disabled={false}
            />
          }
        />
        <Route path="/login" element={<Authentication.Login />} />
        <Route path="/verify-mfa" element={<MfaVerification />} />
        <Route path="/forgot" element={<Authentication.ForgotPassword />} />
        <Route
          path="/reset/:resetKey"
          element={<Authentication.ResetPassword />}
        />
        <Route path="/invite/:inviteKey" element={<Invite />} />
        <Route path="/welcome" element={<RegisterContainer />} />

        {/* Secure routes */}
        <Route
          path="*"
          element={
            <SecureRoute>
              <Layouts.General>
                <Routes>
                  {/* Home and dashboard */}
                  <Route
                    path="/"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <HomePage />
                    )}
                  />
                  <Route
                    path="/home"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <HomePage />
                    )}
                  />

                  {/* Stripe, Salesforce, Invite, etc. */}
                  <Route
                    path="/stripe/:operation"
                    element={<StripeConnector />}
                  />
                  <Route
                    path="/salesforce/connect"
                    element={<SalesforceConnection />}
                  />

                  {/* Franchise Hub */}
                  <Route
                    path="/hub/:franchiseId"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <FranchiseHub />
                    )}
                  />

                  {/* TapNdonate */}
                  <Route
                    path="/tap-n-donate/:tab"
                    element={privateRoute(
                      [userRolesStrings.systemAdmin],
                      <TapNdonateContainer />
                    )}
                  />

                  {/* Campaigns, VIP, Events, etc. (all routes preserved) */}
                  <Route
                    path="/campaigns/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <CampaignPageContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/:id/backoffice"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <React.Suspense fallback={<div />}>
                        {React.createElement(
                          React.lazy(
                            () =>
                              import('../../pages/backoffice/BackofficeCampaignScreen')
                          )
                        )}
                      </React.Suspense>
                    )}
                  />
                  <Route
                    path="/campaigns/:id/backoffice/email-report"
                    element={privateRoute(
                      [userRolesStrings.systemAdmin],
                      <React.Suspense fallback={<div />}>
                        {React.createElement(
                          React.lazy(
                            () =>
                              import('../../pages/backoffice/emailReport/EmailReportPage')
                          )
                        )}
                      </React.Suspense>
                    )}
                  />
                  <Route
                    path="/vip-program/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <ProgramViewPageContainer />
                    )}
                  />
                  <Route
                    path="/vip-program/event/:eventId/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin
                      ],
                      <EventAmbassadorViewPageContainer />
                    )}
                  />
                  <Route
                    path="/vip-program/campaign/:campaignId/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <CampaignAmbassadorViewPageContainer />
                    )}
                  />
                  <Route
                    path="/vip-program/create/:step?"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin
                      ],
                      <CreateVipProgramContainer />
                    )}
                  />
                  <Route
                    path="/vip-program/edit/:eventId/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin
                      ],
                      <EditVipProgramContainer />
                    )}
                  />
                  <Route
                    path="/vip-program/:eventId/add-organization/:step?"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin
                      ],
                      <CreateProgramContainer />
                    )}
                  />
                  <Route
                    path="/vip-program/campaign/edit/:campaignId/:step?"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditProgramContainer />
                    )}
                  />
                  <Route
                    path="/vip-program/vip/:id/:step?"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditApplicationContainer />
                    )}
                  />
                  <Route
                    path="/vip-program/application/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditApplicationContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/create/:template1/:template2?/step/:step?"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin
                      ],
                      <CreateCampaignContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/edit/:id/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditCampaignContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/clone/:id/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin
                      ],
                      <CloneCampaignContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/performance/:campaignId"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <CampaignPerformanceContainer />
                    )}
                  />
                  <Route
                    path="/events/performance/:eventId"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin
                      ],
                      <EventPerformanceContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/view/:view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <ViewCampaignContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/:campaignId/fundraiser/view/:view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <FundraiserViewContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/:campaignId/team/view/:view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <TeamViewContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/:campaignId/collection/view/:view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <CollectionViewContainer />
                    )}
                  />
                  <Route
                    path="/campaigns/:campaignId/check-in"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin
                      ],
                      <CheckInPage />
                    )}
                  />
                  <Route
                    path="/campaigns/:id/page/create/:teamId?/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <CreatePageContainer />
                    )}
                  />
                  {/* below is usually used for campaign but can be used dynamically eslewhere */}
                  <Route
                    path="/:menu/collection/edit/:id/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditCollectionPageContainer />
                    )}
                  />
                  <Route
                    path="/:menu/team/edit/:id/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditTeamPageContainer />
                    )}
                  />
                  <Route
                    path="/:menu/fundraiser/edit/:id/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditFundraiserPageContainer />
                    )}
                  />
                  <Route
                    path="/organizations"
                    element={privateRoute(
                      [userRolesStrings.systemAdmin],
                      <OrganizationPageContainer />
                    )}
                  />
                  <Route
                    path="/organization/:id/backoffice"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <React.Suspense fallback={<div />}>
                        {React.createElement(
                          React.lazy(
                            () =>
                              import('../../pages/backoffice/BackofficeOrganizationScreen')
                          )
                        )}
                      </React.Suspense>
                    )}
                  />
                  <Route
                    path="/organizations/create/:step"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <CreateOrganizationContainer />
                    )}
                  />
                  <Route
                    path="/organizations/edit/:id/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin
                      ],
                      <EditOrganizationContainer />
                    )}
                  />
                  <Route
                    path="/accounts/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin
                      ],
                      <AdminsListContainer />
                    )}
                  />
                  <Route
                    path="/accounts/detail/:id/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin
                      ],
                      <AccountDetailPageContainer />
                    )}
                  />
                  <Route
                    path="/accounts/detail/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin
                      ],
                      <AccountDetailPageContainer />
                    )}
                  />
                  <Route
                    path="/accounts/settings/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <AccountSettingsPageContainer />
                    )}
                  />
                  <Route
                    path="/accounts/settings/:id/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <AccountSettingsPageContainer />
                    )}
                  />
                  <Route
                    path="/export-history"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <ExportHistoryDashboard />
                    )}
                  />
                  <Route
                    path="/webhooks"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin
                      ],
                      <Webhooks />
                    )}
                  />
                  <Route
                    path="/webhooks/setup"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin
                      ],
                      <CreateWebhook />
                    )}
                  />
                  <Route
                    path="/webhooks/edit/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin
                      ],
                      <EditWebhook />
                    )}
                  />

                  {/* System Settings */}
                  <Route
                    path="/system-settings"
                    element={privateRoute(
                      [userRolesStrings.systemAdmin],
                      <SystemSettings />
                    )}
                  >
                    <Route index element={<Navigate to="health" replace />} />
                    <Route path="health" element={<SystemHealth />} />
                    <Route path="franchises" element={<FranchisesContent />} />
                    <Route
                      path="franchises/create"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <CreateFranchiseContent />
                      )}
                    />
                    <Route
                      path="franchises/edit/:id"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <EditFranchiseContent />
                      )}
                    />
                    <Route
                      path="campaign-organizers"
                      element={<CampaignOrganizersContent />}
                    />
                    <Route
                      path="campaign-organizers/create"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <CreateCampaignOrganizerContent />
                      )}
                    />
                    <Route
                      path="campaign-organizers/edit/:id"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <EditCampaignOrganizerContent />
                      )}
                    />
                    <Route
                      path="event-organizers"
                      element={<EventOrganizersContent />}
                    />
                    <Route
                      path="event-organizers/create"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <CreateEventOrganizerContent />
                      )}
                    />
                    <Route
                      path="event-organizers/edit/:id"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <EditEventOrganizerContent />
                      )}
                    />
                    <Route path="access-keys" element={<AccessKeysContent />} />
                    <Route
                      path="access-keys/create"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <CreateAccessKeyContent />
                      )}
                    />
                    <Route
                      path="url-unlocking"
                      element={privateRoute(
                        [userRolesStrings.systemOwner],
                        <UrlUnlocking />
                      )}
                    />
                    <Route
                      path="disable-organization"
                      element={privateRoute(
                        [userRolesStrings.systemOwner],
                        <DisableOrganization />
                      )}
                    />
                    <Route
                      path="bulk-charge-guarantee"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <BulkChargeGuarantee />
                      )}
                    />
                    <Route
                      path="add-organization-to-events"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <AddOrganizationToEvents />
                      )}
                    />
                    <Route
                      path="add-organization-to-events/:organizationId"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <AddOrganizationToEvents />
                      )}
                    />
                    <Route
                      path="consent-document-versions"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <ConsentDocumentVersions />
                      )}
                    />
                    <Route
                      path="gift-matching-pools"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <GiftMatchingPools />
                      )}
                    />
                    <Route
                      path="gift-matching-pools/create"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <GiftMatchingPoolCreate />
                      )}
                    />
                    <Route
                      path="gift-matching-pools/edit/:id"
                      element={privateRoute(
                        [userRolesStrings.systemReadWrite],
                        <GiftMatchingPoolEdit />
                      )}
                    />
                    <Route path="audit-trail" element={<AuditTrail />} />
                  </Route>

                  <Route
                    path="/donations"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin
                      ],
                      <DonationsListContainer />
                    )}
                  />
                  <Route
                    path="/donation/:id/transfer/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <TransferDonationContainer />
                    )}
                  />
                  <Route
                    path="/donations/create/:campaignId?/:pageType?/:id?/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <CreateOfflineDonationContainer />
                    )}
                  />
                  <Route
                    path="/donations/edit/:id/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditDonationContainer />
                    )}
                  />
                  <Route
                    path="/donations/view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <DonationViewPage />
                    )}
                  />
                  <Route
                    path="/events/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin
                      ],
                      <EventPageContainer />
                    )}
                  />
                  <Route
                    path="/events/:id/backoffice"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <React.Suspense fallback={<div />}>
                        {React.createElement(
                          React.lazy(
                            () =>
                              import('../../pages/backoffice/BackofficeEventScreen')
                          )
                        )}
                      </React.Suspense>
                    )}
                  />
                  <Route
                    path="/events/view/:view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.eventOrganizerAdmin
                      ],
                      <ViewEventContainer />
                    )}
                  />
                  <Route
                    path="/events/create/:step"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <CreateEventContainer />
                    )}
                  />
                  <Route
                    path="/events/edit/:id/:step"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <EditEventContainer />
                    )}
                  />
                  <Route
                    path="/events/clone/:id/:step"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <CloneEventContainer />
                    )}
                  />
                  <Route
                    path="/events/active-integration/:id/:step"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <ActiveIntegrationContainer />
                    )}
                  />
                  <Route
                    path="/sales/:tab?"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <SalesListContainer />
                    )}
                  />
                  <Route
                    path="/fundraisers/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <FundraiserPageContainer />
                    )}
                  />
                  <Route
                    path="/fundraisers/view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <FundraiserViewPage />
                    )}
                  />
                  <Route
                    path="/fundraisers/team/view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <React.Suspense fallback={<div />}>
                        {React.createElement(
                          React.lazy(() => import('../../pages/team/view'))
                        )}
                      </React.Suspense>
                    )}
                  />
                  <Route
                    path="/fundraisers/collection/view/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <React.Suspense fallback={<div />}>
                        {React.createElement(
                          React.lazy(
                            () => import('../../pages/collection/view')
                          )
                        )}
                      </React.Suspense>
                    )}
                  />
                  <Route
                    path="/sales/view/:saleId/"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <ViewTicketingContainer />
                    )}
                  />
                  <Route
                    path="/sales/edit/:saleId/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <EditTicketingContainer />
                    )}
                  />
                  <Route
                    path="/sales/create/:campaignId?/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <CreateTicketingContainer />
                    )}
                  />
                  <Route
                    path="/merchandise"
                    element={privateRoute(
                      [userRolesStrings.systemAdmin],
                      <MerchandisePageContainer />
                    )}
                  />
                  <Route
                    path="/merchandise/create/:step"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <CreateMerchandiseContainer />
                    )}
                  />
                  <Route
                    path="/merchandise/edit/:id/:step"
                    element={privateRoute(
                      [userRolesStrings.systemReadWrite],
                      <EditMerchandiseContainer />
                    )}
                  />
                  <Route
                    path="/recurring/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin
                      ],
                      <RecurringPageContainer />
                    )}
                  />
                  {/*
                  <Route path="/recurring/create/:step" element={privateRoute([
                    userRolesStrings.systemAdmin,
                    userRolesStrings.organizationAdmin
                  ], <CreateRecurringDonationContainer />)} />
                  */}
                  <Route
                    path="/recurring/edit/:id/:step"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin
                      ],
                      <EditRecurringDonationContainer />
                    )}
                  />
                  <Route
                    path="/recurring/transfer/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemReadWrite,
                        userRolesStrings.organizationAdmin
                      ],
                      <TransferDonationSubscriptionContainer />
                    )}
                  />
                  <Route
                    path="/recurring/detail/:id/:tab"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin
                      ],
                      <RecurringDonationViewPageContainer />
                    )}
                  />
                  <Route
                    path="/content-moderation"
                    element={privateRoute(
                      [userRolesStrings.systemAdmin],
                      <ContentModerationQueueScreen />
                    )}
                  />
                  <Route
                    path="/content-moderation/event/:id"
                    element={privateRoute(
                      [userRolesStrings.systemAdmin],
                      <ContentModerationReviewEventScreen />
                    )}
                  />
                  <Route
                    path="/:view/dashboard/compare"
                    element={privateRoute(
                      [userRolesStrings.systemAdmin],
                      <DashboardCompareContainer />
                    )}
                  />
                  <Route
                    path="/:view/dashboard/:id"
                    element={privateRoute(
                      [
                        userRolesStrings.systemAdmin,
                        userRolesStrings.organizationAdmin,
                        userRolesStrings.eventAdmin,
                        userRolesStrings.campaignAdmin,
                        userRolesStrings.eventOrganizerAdmin,
                        userRolesStrings.campaignOrganizerAdmin
                      ],
                      <DashboardContainer />
                    )}
                  />
                  {/* Redirects (Navigate) */}
                  <Route
                    path="/campaigns"
                    element={
                      <Navigate to={config.DEFAULT_CAMPAIGNS_URL} replace />
                    }
                  />
                  <Route
                    path="/fundraisers"
                    element={
                      <Navigate to={config.DEFAULT_FUNDRAISERS_URL} replace />
                    }
                  />
                  <Route
                    path="/events"
                    element={
                      <Navigate to={config.DEFAULT_EVENTS_URL} replace />
                    }
                  />
                  <Route
                    path="/tap-n-donate"
                    element={
                      <Navigate to={config.DEFAULT_TAP_N_DONATE_URL} replace />
                    }
                  />
                  <Route
                    path="/recurring"
                    element={
                      <Navigate to={config.DEFAULT_RECURRING_URL} replace />
                    }
                  />
                  <Route
                    path="/accounts"
                    element={
                      <Navigate
                        to={
                          isSystemAdmin
                            ? config.DEFAULT_SYS_ADMIN_ACCOUNTS_URL
                            : config.DEFAULT_ACCOUNTS_URL
                        }
                        replace
                      />
                    }
                  />
                  {/* Fallback for unmatched routes */}
                  <Route path="*" element={<UnmatchedRouteLogger />} />
                </Routes>
              </Layouts.General>
            </SecureRoute>
          }
        />
      </Routes>
    </div>
  );
}

const mapState = ({ session }: any) => ({
  isSystemAdmin: session.isSystemAdmin,
  isOrganizationAdmin: session.isOrganizationAdmin,
  isEventAdmin: session.isEventAdmin,
  isCampaignAdmin: session.isCampaignAdmin,
  isEventOrganizerAdmin: session.isEventOrganizerAdmin,
  isCampaignOrganizerAdmin: session.isCampaignOrganizerAdmin,
  adminRole: session.adminRole,
  sessionKey: session.key
});

// Only use action creators for bindActionCreators
const mapDispatch = (dispatch: any) => bindActionCreators({
  resumeSession: sessionActionCreators.resumeSession,
  fetchFeatureFlags
}, dispatch);

export default InjectReCaptcha(
  ping(connect(mapState, mapDispatch)(App))
);
